module.exports = __webpack_public_path__ + "static-appopensalud/img/opensalud360_healthierlives_blue.770f0a2.svg";


//////////////////
// WEBPACK FOOTER
// ./static-appopensalud/img/logos/opensalud360_healthierlives_blue.svg
// module id = 1036
// module chunks = 116